import FuelVolumeTable from "./component/FuelVolumeTable";

const FuelVolume = () => {
  return (
    <>
      <FuelVolumeTable />
    </>
  );
};

export default FuelVolume;
